import axios from 'axios'

/** Calls to the mis backend, proxied through the BFF (which injects the JWT). */
export const api = axios.create({
  baseURL: '/api/services/mis-be',
  withCredentials: true,
})

/** Calls to the BFF's own session-auth endpoints. */
export const bff = axios.create({
  baseURL: '/bff',
  withCredentials: true,
})

/** Public (unauthenticated) backend endpoints — invite redeem. */
export const publicApi = axios.create({
  baseURL: '/api/services/mis-be/public',
  withCredentials: true,
})
